<template>
	<div class="content">
		<router-view />
	</div>
</template>

<script>
	export default {
		created() {
			if (!this.allow_user("super-admin")) {
				this.$router.replace("/");
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/Administrators.vue